import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

import'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../config/config.service';
import { Product } from '../products/product';
import { ProductsService } from '../products/products.service';
import { ProductImageService } from '../products/product-image.service';
import { ProductImage } from '../products/product-image';
import { LoggingService } from '../loging/logging.service';
export class ProductAdminDetailsComponent implements OnInit {
    product: Product;
    productId: string;
    productImages: Observable<ProductImage[]>;
    //productImages: ProductImage[];
    file: any;
    awsBucket: string;
    mainImageUrl: string;
    newProduct: boolean;
private config: any;
/**
 * @param {?} configService
 * @param {?} productService
 * @param {?} productImageService
 * @param {?} route
 * @param {?} location
 * @param {?} loggingService
 */
constructor(
private configService: ConfigService,
private productService: ProductsService,
private productImageService: ProductImageService,
private route: ActivatedRoute,
private location: Location,
private loggingService: LoggingService
    ) {
        this.configService.getConfig(
            (config: any) => {
                this.config = config;

                this.awsBucket = this.config.awsBucket;
            });
    }
/**
 * @return {?}
 */
ngOnInit() {
        this.loggingService.log('product-details.component:ngOnInit()');
        this.route.params.filter((item) => { return item['id']; }).subscribe((next) => {
            if (next['id'] == 'NewProduct') {
                this.newProduct = true;

                this.product = new Product();
                this.productId = this.product.id;
            } else {
                this.productId = next['id'];
                this.newProduct = false;

                this.route.params.switchMap((params: Params) =>
                    this.productService.getProduct(params['id']))
                    .subscribe((product) => {
                        this.product = product;

                        //alert(this.configService.getConfig('test2'));
                        this.getProductImages();
                    });
            }
        });

    }
/**
 * @return {?}
 */
goBack(): void {
        this.location.back();
    }
/**
 * @return {?}
 */
save(): void {
        if (this.newProduct) {
            this.productService.createProduct(this.product).subscribe((product) => {
                this.product = product;
                this.goBack();
            });
        } else {
            this.productService.updateProduct(this.product)
                .subscribe(() => this.loggingService.log('this.product.id = ' + this.product.id));

            if (this.file) {
                this.productImageService.getMainImageSignature(this.file.type, this.product.id)
                    .subscribe((response) => this.afterSignRequest(response));
            }
        }
    }
/**
 * @return {?}
 */
onMainImageChange(): void {
        let /** @type {?} */ fileInputElement: any = document.getElementById("mainImagePicker");
        this.file = fileInputElement.files[0];
    }
/**
 * @param {?} key
 * @return {?}
 */
onImageChange(key: string): void {
        let /** @type {?} */ fileInputElement: any = document.getElementById("imagePicker");
        this.file = fileInputElement.files[0];
        this.loggingService.log('key = ' + key);
    }
/**
 * @param {?} file
 * @param {?} signed_request
 * @param {?} url
 * @param {?} done
 * @return {?}
 */
upload(file: any, signed_request: string, url: string, done: any) {
        let /** @type {?} */ xhr = new XMLHttpRequest();
        xhr.open("PUT", signed_request);
        xhr.setRequestHeader('x-amz-acl', 'public-read');
        xhr.onload = () => {
            if (xhr.status === 200) {
                done(url, this);
            } else if (xhr.status === 403) {
                this.delete(file, signed_request, url, done);
            }
        }
        xhr.send(file);
    }
/**
 * @param {?} file
 * @param {?} signed_request
 * @param {?} url
 * @param {?} done
 * @return {?}
 */
delete(file: any, signed_request: string, url: string, done: any) {
        let /** @type {?} */ xhr = new XMLHttpRequest();
        xhr.open("DELETE", signed_request);
        xhr.onload = () => {
            if (xhr.status === 200) {
                this.upload(file, signed_request, url, done);
            }
        }
        xhr.send();
    }
/**
 * @return {?}
 */
deleteMainImage() {
        this.productImageService.deleteMainImage(this.product.id)
            .subscribe(() => this.afterDeleteMainImage());
    }
/**
 * @param {?} response
 * @return {?}
 */
afterGetDeleteMainImageAuthorizationHeader(response: any): void {
        const /** @type {?} */ url = this.awsBucket + 'img/' + this.product.id + '/main.jpg?now=' + new Date().getTime();

        let /** @type {?} */ xhr = new XMLHttpRequest();
        xhr.open("DELETE", url);
        xhr.setRequestHeader('Authorization', response.Authorization);
        xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
        xhr.onload = () => {
            if (xhr.status === 200) {
                let /** @type {?} */ mainImageElement: any = document.getElementById('mainImage');
                mainImageElement.src = "";
            }
        }
        xhr.send();       
    }
/**
 * @return {?}
 */
afterDeleteMainImage(): void {
        let /** @type {?} */ mainImageElement: any = document.getElementById('mainImage');
        mainImageElement.src = '';
    }
/**
 * @param {?} response
 * @return {?}
 */
afterSignRequest(response: any): void {
        this.upload(this.file, response.signed_request, response.url, this.afterFileUpload);
    }
/**
 * @param {?} url
 * @param {?} thisObject
 * @return {?}
 */
afterFileUpload(url: string, thisObject: any): void {
        this.loggingService.log(url);
        thisObject.getProductImages();
        thisObject.location.replaceState(window.location.href);
    }
/**
 * @return {?}
 */
getProductImages(): void {
        this.productImageService.getProductImages(this.product.id).subscribe(
            productImages => {
                this.productImages = productImages;

                if (this.productImages[0]) {
                    this.mainImageUrl = this.awsBucket + this.productImages[0].Key;
                }
            }
        );
    }
/**
 * @return {?}
 */
addImageOld(): void {
        alert('add image');
        var /** @type {?} */ inputFileElement = document.createElement('input');
        inputFileElement.type = 'file';
        inputFileElement.onchange = () => {
            alert('change');
            this.file = inputFileElement.files[0];
            alert('this.file.name = ' + this.file.name);
            this.productImageService.getMainImageSignature(this.file.type, this.product.id)
                .subscribe((response) => {
                    return this.afterSignRequest(response);
                });
        };
        inputFileElement.style.visibility = "hidden";

        document.body.appendChild(inputFileElement);
        inputFileElement.click();
    }
/**
 * @return {?}
 */
addImage(): void {
        let /** @type {?} */ addImageInputElement: any = document.getElementById("addImageInput");
        addImageInputElement.style.visibility = "visible";

        addImageInputElement.click();
    }
/**
 * @return {?}
 */
imageAdded(): void {
        let /** @type {?} */ addImageInputElement: any = document.getElementById("addImageInput");
        this.file = addImageInputElement.files[0];
        var /** @type {?} */ fileName = prompt("Input image name", this.file.name);
        this.productImageService.getImageSignature(this.file.type, this.product.id, fileName)
            .subscribe((response) => {
                let /** @type {?} */ addImageInputElement: any = document.getElementById("addImageInput");
                addImageInputElement.style.visibility = "hidden";
                return this.afterSignRequest(response);
            });
    }
/**
 * @param {?} imageId
 * @return {?}
 */
moveImageUp(imageId: string): void {
        this.productImageService.moveImageUp(imageId)
            .subscribe(productImages => {
                this.productImages = productImages;
                this.mainImageUrl = this.awsBucket + this.productImages[0].Key;
            });
    }
/**
 * @param {?} imageId
 * @return {?}
 */
moveImageDown(imageId: string): void {
        this.productImageService.moveImageDown(imageId)
            .subscribe(productImages => {
                this.productImages = productImages;
                this.mainImageUrl = this.awsBucket + this.productImages[0].Key;
            });

    }
/**
 * @param {?} imageId
 * @return {?}
 */
deleteImage(imageId: string): void {
        this.productImageService.deleteImage(imageId)
            .subscribe(rawResponse => {
                if (rawResponse.ok) {
                    this.getProductImages();
                };
            });
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'my-product-admin-details',
    template: "<div class=\"product-admin-details\" *ngIf=\"product\"> <h2>{{product.name}} details</h2> <div> <img id=\"mainImage\" src=\"{{mainImageUrl}}\" class=\"main-product-image\" alt=\"Main mouse image\" /> <label>name: </label> <div class=\"input-div\"> <input [(ngModel)]=\"product.name\" placeholder=\"name\"> </div> <label>decription: </label> <div class=\"input-div\"> <textarea style=\"height:3em;\" [(ngModel)]=\"product.description\" placeholder=\"decription\"></textarea> </div> <label>price: </label> <div class=\"input-div\"> <input [(ngModel)]=\"product.price\" placeholder=\"price\"> </div> <div class=\"product-images\"> <div *ngFor=\"let productImage of productImages\"> <span *ngIf=\"productImage.DisplayIndex == 0\">Main Image</span>&nbsp;<img id=\"mainImage\" src=\"{{awsBucket + productImage.Key}}\" class=\"product-image\" alt=\"product image\" />&nbsp;&nbsp; <span (click)=\"deleteImage(productImage._id)\" class=\"glyphicon glyphicon-trash\"></span>&nbsp;&nbsp; <span class=\"glyphicon glyphicon-arrow-up\" (click)=\"moveImageUp(productImage._id)\"></span>&nbsp;&nbsp; <span class=\"glyphicon glyphicon-arrow-down\" (click)=\"moveImageDown(productImage._id)\"></span> </div> </div> </div> <button (click)=\"goBack()\">Back</button> <button (click)=\"save()\">Save</button> <button *ngIf=\"!newProduct\" (click)=\"addImage()\">Add Image</button> <input style=\"visibility:hidden\" type=\"file\" class=\"add-image-input-button\" id=\"addImageInput\" (change)=\"imageAdded()\" value=\"Add Image\" /> </div> <p>Product Categories</p> <my-product-product-categories-editor *ngIf=\"!newProduct\" [productId]=\"productId\"></my-product-product-categories-editor>  ",
    styles: ["label { display: inline-block; width: 3em; margin: .5em 0; color: #607D8B; font-weight: bold; } input { height: 2em; font-size: 1em; padding-left: .4em; } button { margin-top: 20px; font-family: Arial; background-color: #eee; border: none; padding: 5px 10px; border-radius: 4px; cursor: pointer; cursor: hand; } button:hover { background-color: #cfd8dc; } button:disabled { background-color: #eee; color: #ccc; cursor: auto; } .input-div { width: 100%; } .input-div input { width: 100%; } .input-div textarea { width: 100%; } .product-admin-details { overflow: scroll; } .product-image { height: 4em; } .main-product-image { height: 7em; }"]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConfigService, },
{type: ProductsService, },
{type: ProductImageService, },
{type: ActivatedRoute, },
{type: Location, },
{type: LoggingService, },
];
}

function ProductAdminDetailsComponent_tsickle_Closure_declarations() {
/** @type {?} */
ProductAdminDetailsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProductAdminDetailsComponent.ctorParameters;
/** @type {?} */
ProductAdminDetailsComponent.prototype.product;
/** @type {?} */
ProductAdminDetailsComponent.prototype.productId;
/** @type {?} */
ProductAdminDetailsComponent.prototype.productImages;
/** @type {?} */
ProductAdminDetailsComponent.prototype.file;
/** @type {?} */
ProductAdminDetailsComponent.prototype.awsBucket;
/** @type {?} */
ProductAdminDetailsComponent.prototype.mainImageUrl;
/** @type {?} */
ProductAdminDetailsComponent.prototype.newProduct;
/** @type {?} */
ProductAdminDetailsComponent.prototype.config;
/** @type {?} */
ProductAdminDetailsComponent.prototype.configService;
/** @type {?} */
ProductAdminDetailsComponent.prototype.productService;
/** @type {?} */
ProductAdminDetailsComponent.prototype.productImageService;
/** @type {?} */
ProductAdminDetailsComponent.prototype.route;
/** @type {?} */
ProductAdminDetailsComponent.prototype.location;
/** @type {?} */
ProductAdminDetailsComponent.prototype.loggingService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
